import {RouteTabParameter} from '../../types/common/RouteTabParameter';


export interface IContentItemPaths {
  ContentItemEdit: string,
  ContentItemCreate: string,
  ContentItemProfile: string,
  ContentItemSearch: string,
}

export const contentItemPaths: IContentItemPaths = {
  ContentItemEdit: '/content-assets/edit/:idParam',
  ContentItemCreate: '/content-assets/create',
  ContentItemProfile: '/content-assets/view/:idParam',
  ContentItemSearch: '/content-assets/search',
};

export interface IContentItemProfileTabs {
  activity: RouteTabParameter;
  details: RouteTabParameter;
}

export const contentItemProfileTabs: IContentItemProfileTabs = {
  activity: new RouteTabParameter(0, 'Activity', 'activity'),
  details: new RouteTabParameter(1, 'Details', 'details'),
}

export const contentItemTabs = [
  contentItemProfileTabs.activity,
  contentItemProfileTabs.details
];

export const getContentItemProfileTabs = (query: string | undefined | null) => contentItemTabs.find(x => x.query === query);